import type { ReactNode } from 'react';

interface ViewWrapperProps {
  children: ReactNode;
}

export const ViewWrapper = ({ children }: ViewWrapperProps) => (
  <div className="h-full overflow-auto flex flex-col gap-3 mt-2">
    {children}
  </div>
);

interface ChipProps {
  children: ReactNode;
}

export const Chip = ({ children }: ChipProps) => (
  <span className="inline-flex items-center px-2 py-1 rounded-md border border-navy-200 text-sm text-gray-700">
    {children}
  </span>
);

export const ChipSkeleton = () => (
  <span className="inline-flex items-center px-3 py-1.5 rounded-md border border-navy-200 mr-2 mb-2 text-sm">
    <span className="block h-3 w-24 bg-gray-100 animate-pulse rounded" />
  </span>
);
